import React, { useRef } from 'react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { SuccessAlert } from '../alert/SuccessAlert';

import './style.css';
import { colorTheme } from '../../utilities/ColorTheme';
import { FaPlus } from 'react-icons/fa';
import { BASE_URL, Endpoints } from '../../constants/urls';
import axios from 'axios';

export const AddRecordings = ({
  updateNotificationsList,
  setUpdateNotificationsList,
  setIsAnnoucementReload,
  handleClose,
}) => {
  const [alert, setAlert] = useState(false);
  const [error, setError] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [recordingUrl, setRecordingUrl] = useState(
    updateNotificationsList.recordingURLs[0]?.recordingURL
  );
  const [materialFileName, setMaterialFileName] = useState();

  useEffect(() => {
    if (updateNotificationsList.recordingURLs[0]?.materialURL) {
      const material_file_name =
        updateNotificationsList.recordingURLs[0]?.materialURL.split('/').pop();
      setMaterialFileName(material_file_name);
    }
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log('file', file);
    setSelectedFile(file);
    setMaterialFileName(file.name);
  };

  const handleInputChange = (e) => {
    const { value } = e.target;
    setRecordingUrl(value);
  };
  const uploadFile = async (e) => {
    e.preventDefault();
    const accessToken = localStorage.getItem('accessToken');
    if (selectedFile) {
      const formData = new FormData();
      formData.append('file', selectedFile);
      try {
        const url = BASE_URL + Endpoints.UploadImage;
        const response = await axios.post(url, formData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response.status === 200) {
          addVideoUrl(response.data.fileUrl);
        }
      } catch (err) {
        console.log('error', err);
      }
    } else {
      addVideoUrl(updateNotificationsList.recordingURLs[0]?.materialURL);
    }
  };

  const addVideoUrl = async (fileURL) => {
    const accessToken = localStorage.getItem('accessToken');

    try {
      const url = BASE_URL + Endpoints.AddUpdateEventRecording;
      const eventData = {
        Id: updateNotificationsList.recordingURLs[0]?.id
          ? updateNotificationsList.recordingURLs[0]?.id
          : 0,
        eventId: updateNotificationsList.id,
        RecordingURL: recordingUrl ? recordingUrl : '',
        MaterialURL: fileURL ? fileURL : '',
      };

      const res = await axios.post(url, eventData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setAlert(true);

      setAlert(true);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    return () => {
      resetForm();
    };
  }, []);

  const resetForm = () => {
    // setUpdateNotificationsList(false);
  };
  return (
    <>
      <div className='sentNotifiMain'>
        <form>
          <label className='form-label mb-0'>Recording Url</label>
          <div
            className='mb-3 w-100'
            style={{
              flexDirection: 'column',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}
            >
              <div
                className='w-100'
                style={{
                  justifyContent: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <input
                  type='text'
                  name='recordingurl'
                  value={recordingUrl}
                  onChange={(e) => handleInputChange(e)}
                  className='doctor-name-input'
                  placeholder='Enter Recording Url'
                />
              </div>

              <div
                style={{
                  display: 'flex',

                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  alignSelf: 'center',

                  marginLeft: 10,
                }}
              ></div>
            </div>
          </div>
          <label className='form-label mb-0 presentation-material-label'>
            Presentation Material
          </label>
          <label htmlFor='image-upload' className='image-upload-button'>
            <div
              style={{
                backgroundColor: colorTheme.primaryBlue,
                paddingRight: 6,
                paddingLeft: 6,
                borderRadius: 4,
                color: 'white',
                // width: 100,
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 10,
              }}
            >
              Upload File
            </div>
          </label>
          <input
            id='image-upload'
            type='file'
            accept='file/*'
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          <p>{materialFileName}</p>
          <button
            onClick={uploadFile}
            style={{
              alignSelf: 'flex-end',
              marginTop: 30,
              position: 'absolute',
              right: 20,
              bottom: 10,
            }}
            className='reidPrimaryBtn btn'
          >
            Save
          </button>
        </form>
      </div>
      {alert && (
        <SuccessAlert
          message={
            updateNotificationsList
              ? 'Event updated successfully!'
              : 'Event added successfully!'
          }
          onClose={() => {
            setUpdateNotificationsList(false);
            setIsAnnoucementReload(true);
            setAlert(false);
            handleClose();
          }}
        />
      )}
    </>
  );
};
